module.exports = __webpack_public_path__ + "media/images/ticket/back_to_cart_ov-000082ae5acba27896aac4fa37baa28e.png";